<template>
<v-container fluid class="login-page fill-height">
    <v-row align="center" justify="center" class="fill-height">
      <v-col cols="12" sm="10" md="9" lg="8">
        <v-card class="auth-card rounded-xl overflow-hidden" elevation="8">
          <v-row no-gutters>
            <v-col cols="12" md="5" class="d-none d-md-flex">
              <v-img src="/images/login2.jpg" class="auth-visual" gradient="to bottom, rgba(30,60,114,.15), rgba(20,35,63,.92)">
                <div class="d-flex flex-column fill-height justify-end pa-8 white--text">
                  <v-icon size="44" class="mb-3">mdi-school</v-icon>
                  <div class="text-h5 font-weight-bold">Welcome Back</div>
                  <div class="auth-visual-subtitle mt-2">
                    Sign in to manage your school's results, students, attendance and more — all in one place.
                  </div>
                </div>
              </v-img>
            </v-col>
            <v-col cols="12" md="7">
              <v-card-text class="pa-8 pa-md-10">
                <div class="text-overline font-weight-bold accent--text">SCHOOL ADMIN</div>
                <div class="text-h5 font-weight-bold mb-1">Sign in to your account</div>
                <div class="text-body-2 grey--text mb-6">Enter your credentials to access your dashboard.</div>

                <v-form ref="form">
                  <v-text-field
                  v-model="record.email"
                  label="E-mail Address"
                  prepend-inner-icon="mdi-email-outline"
                  outlined
                  required
                  class="mb-1"
                  ></v-text-field>

                  <v-text-field
                  v-model="record.password"
                  label="Password"
                  type="password"
                  prepend-inner-icon="mdi-lock-outline"
                  outlined
                  required
                  ></v-text-field>

                  <v-btn
                  color="primary"
                  block
                  large
                  rounded
                  elevation="2"
                  class="font-weight-bold text-none mt-2"
                  @click="post"
                  >
                  Sign In
                  <v-icon right>mdi-arrow-right</v-icon>
                  </v-btn>

                  <div class="text-center mt-5">
                    <v-btn text small class="text-none" to="recover-password" color="primary">
                      Forgot your password?
                    </v-btn>
                  </div>
                </v-form>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
        <div class="text-center mt-3">
          <a class="image-credit" href="https://www.freepik.com/free-vector/hand-drawn-woman-with-drink_18037239.htm#fromView=keyword&page=1&position=6&uuid=5fa1b5bc-1053-4a01-a73d-94371d2f11eb" target="_blank">Image Credits</a>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import axios from 'axios';

  export default {
    name: 'Signin',
    components: {
    },
    mounted() {
       if (this.authToken) {
            this.$router.push({name: 'ModuleSelector'})
       }
    },
    computed: {
        ...mapState({
            isLoggedIn: (state) => state.isLoggedIn,
            isTokenAccess: (state) => state.isTokenAccess,
        })
    },
    data: () => ({
        authToken:sessionStorage.getItem('authToken') ?? null,
        record:{
            email:null,
            password:null,
        },
    }),

    methods: {
        post () {
            let validation = this.$refs.form.validate()
            if(!validation) {
                return validation
            }
            let loader = this.$loading.show()
            axios.post(process.env.VUE_APP_AUTHURL+'/signin', this.record,
            {
                headers:
                    {
                        'Device-Referrer-Id': process.env.VUE_APP_DEVICEID,
                        'X-Auth-Source': 'school',
                    }
            })
            .then((response) => {
                sessionStorage.authToken =  response.data.token
                sessionStorage.loggedUser =   JSON.stringify(response.data.data)
                localStorage.school =  JSON.stringify(response.data.data.school)
                this.$store.dispatch('fetchTokens', response.data.data.school.school_id);
                sessionStorage.utpc =  'Teacher'
                this.$store.commit("isLoggedIn", true);
                sessionStorage.removeItem('accessToken')
                this.$router.push({name: 'ModuleSelector'})
            })
            .catch((error) => {
                this.$toast.error(error.response ? error.response.data.message : 'Server Downtime, Please contact us!', {
                    timeout: 5000
                });
            })
            .finally(() => {
                loader.hide()
            });
        },
    },
  }
</script>

<style scoped>
.login-page {
    min-height: calc(100vh - 64px);
}
.auth-visual {
    height: 100%;
    min-height: 480px;
}
.auth-visual-subtitle {
    opacity: 0.85;
    font-size: 0.9rem;
    max-width: 320px;
}
.image-credit {
    color: #9aa5b8;
    text-decoration: none;
    font-size: 11px;
}
</style>
